import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bancos',
  templateUrl: './bancos.component.html',
  styles: []
})

export class BancosComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}

